import { useMemo } from 'react'

import { Editor } from '@tiptap/core'
import { BubbleMenu } from '@tiptap/react'

import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { MenuItemWrapper } from '../../components/BubbleMenuItemWrapper.js'

import { PollNode } from './index.js'

export function PollMenu({ editor }: { editor: Editor }) {
  const { from } = editor.state.selection

  const node = useMemo(() => {
    return editor.state.doc.nodeAt(from)
  }, [editor, from])

  return (
    <BubbleMenu
      pluginKey="poll-bubble-menu"
      shouldShow={({ editor }) => {
        return editor.isActive(PollNode.name)
      }}
      editor={editor}
      tippyOptions={{
        delay: 0,
        arrow: true,
        placement: 'top',
        moveTransition: 'transform 0.2s ease-out',
        appendTo: 'parent',
        offset: [0, 5],
        maxWidth: '100vw',
      }}
    >
      <div className="rounded-sm divide-y divide-line-subdued text-content-subdued bg-surface shadow-lg border border-line-subdued">
        <div className="overflow-auto flex items-center divide-x divide-line-subdued py-1">
          <MenuItemWrapper>
            <IconButton
              variant="plainNeutral"
              size="sm"
              accessibilityLabel="Edit poll"
              icon={<SvgIcon name="pencil" />}
              onClick={() => {
                editor.commands.editPoll({ id: node.attrs.id })
              }}
            />
          </MenuItemWrapper>
          <MenuItemWrapper>
            <IconButton
              variant="plainNeutral"
              size="sm"
              accessibilityLabel="Edit poll"
              icon={<SvgIcon name="trash" />}
              onClick={() => {
                editor.commands.deleteSelection()
              }}
            />
          </MenuItemWrapper>
        </div>
      </div>
    </BubbleMenu>
  )
}
